import React, {PureComponent} from 'react';
import {withRouter} from 'react-router';

import LineChart from '../LineChart';
import Tooltip from '../Tooltip';
import LargeWidgetValue from '../LargeWidgetValue';
import Number from '../Number';
import WidgetHeader from '../WidgetHeader';
import Button from '../Button';
import Icon from '../Icon';

class NumericWidget extends PureComponent {
  handlePointClick = point => {
    const {history, dashboardWidgetSet} = this.props;
    if(!dashboardWidgetSet) {
      history.push(`${history.location.pathname}/data/${point.payload.rowId}`);
    }
  };

  render() {
    const {sheetsById, answers, question, id, options, unPin, dashboardWidgetSet, step, setStep} = this.props;

    let children = [];
    let filteredOptions = options;
    if(question !== undefined) {
      if(question.pinned) {
        children.push(
          <Button id={`${id}_pin`} tertiary onClick={() => unPin(question)}>
            <Icon name="go-pin"/>
          </Button>
        )
        filteredOptions = options.filter(option => option.title !== "Pin");
      }
    }

    if(answers.length === 1) {
      return (
        <>
          <WidgetHeader
            id={id}
            title={question.text}
            question={question}
            options={filteredOptions}
            children={children}/>
           <LargeWidgetValue>
            <Number>{answers[0].value}</Number>
          </LargeWidgetValue>
        </>
      );
    }

    return (
      <LineChart
        id={id}
        question={question}
        data={answers}
        valueKey="value"
        onClick={this.handlePointClick}
        options={options}
        unPin={unPin}
        dashboardWidgetSet={dashboardWidgetSet}
        step={step}
        setStep={setStep}
        tooltip={answer => {
          if(!dashboardWidgetSet){
            const sheet = sheetsById[answer.sheetId];
            return (
              <Tooltip>
                {Object.keys(sheetsById).length > 1 && (
                  <Tooltip.Title>{sheet.name || 'Unnamed sheet'}</Tooltip.Title>
                )}
                <Tooltip.Value>{answer.value}</Tooltip.Value>
                <Tooltip.Footer>{new Date(answer.dates.lastModified).toLocaleString()}</Tooltip.Footer>
              </Tooltip>
            )
          } else {
            return (
              <Tooltip>
                <Tooltip.Value>{answer.value}</Tooltip.Value>
                <Tooltip.Footer>{new Date(answer.lastModified).toLocaleString()}</Tooltip.Footer>
              </Tooltip>
            )
          }
        }}
      />
    );
  }
}

export default withRouter(NumericWidget);
